module.exports = __webpack_public_path__ + "static/media/md.d1925679.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/md.svg
// module id = 1458
// module chunks = 0